export const locations = [
  {
    slug: 'metal-fabrication-toronto',
    title: 'Custom Metal Fabrication Toronto | Sketch to Quote — MetalMatch',
    heading: 'Custom Metal Fabrication in Toronto',
    description: 'Get custom metal parts fabricated in Toronto — from Etobicoke to Scarborough. Submit a sketch, get matched with vetted local fabricators, compare quotes.',
  },
  {
    slug: 'metal-fabrication-mississauga',
    title: 'Custom Metal Fabrication Mississauga | Sketch to Quote — MetalMatch',
    heading: 'Custom Metal Fabrication in Mississauga',
    description: 'Source precision CNC and sheet metal fabrication in Mississauga, from Dixie Road to the Airport Corporate Centre. No CAD files required to get a quote.',
  },
  {
    slug: 'metal-fabrication-hamilton',
    title: 'Custom Metal Fabrication Hamilton | Sketch to Quote — MetalMatch',
    heading: 'Custom Metal Fabrication in Hamilton',
    description: "Tap into Hamilton's steel and heavy welding heritage for custom metal fabrication — often at lower shop rates than Toronto. Submit a sketch to get started.",
  },
  {
    slug: 'metal-fabrication-gta',
    title: 'Custom Metal Fabrication GTA | Sketch to Quote — MetalMatch',
    heading: 'Custom Metal Fabrication Across the GTA',
    description: 'MetalMatch sources custom metal fabrication across the entire GTA — matching your project to the right shop by capability, not just proximity.',
  },
  {
    slug: 'metal-fabrication-ottawa',
    title: 'Custom Metal Fabrication Ottawa | Sketch to Quote — MetalMatch',
    heading: 'Custom Metal Fabrication in Ottawa',
    description: "Custom metal fabrication across Ottawa and the National Capital Region, including Kanata, Orleans, and Gatineau. Sketch to quote, no CAD required.",
  },
  {
    slug: 'metal-fabrication-kitchener-waterloo',
    title: 'Custom Metal Fabrication Kitchener-Waterloo | Sketch to Quote — MetalMatch',
    heading: 'Custom Metal Fabrication in Kitchener-Waterloo',
    description: "Custom metal fabrication in Kitchener-Waterloo and Cambridge, from tool-and-die shops to hardware prototyping. Submit a sketch to get matched with a fabricator.",
  },
];
